import allServices from '../ProviderServices.json';
import config from '../config';

/**
 * Returns the list of available provider services filtered for the current region.
 * On the US site (isIndia = false), Priest service is excluded.
 * On the India site (isIndia = true), all services are returned.
 */
export function getProviderServices() {
  if (config.isIndia) return allServices;
  return allServices.filter(item => item.slug !== 'hire-a-priest');
}
